import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmComponent } from '../components/confirm/confirm.component';
import { PromptComponent } from '../components/prompt/prompt.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(
    private $dialog: MatDialog,
  ) { }

  confirm(
    cb,
    message: string,
    message2 = '',
    yBtnTxt = 'Yes',
    nBtnTxt = 'No'
  ): void {
    const data = {
      message,
      yBtnTxt,
      nBtnTxt,
      message2
    };
    const $dialogRef = this.$dialog.open(
      ConfirmComponent,
      {
        autoFocus: false,
        width: 'auto',
        height: 'auto',
        minHeight: '12rem',
        minWidth: '20rem',
        data,
        disableClose: true,
        panelClass: 'confirm-dialog'
      }
    );

    $dialogRef.afterClosed().subscribe(res => {
      cb(res);
    });
  }

  prompt(
    cb,
    message: string,
    title = 'Prompt',
    placeholder = '',
    okBtnTxt = 'OK',
    cancelBtnTxt = 'Cancel'
  ): void {
    const data = {
      message,
      title,
      placeholder,
      okBtnTxt,
      cancelBtnTxt
    };
    const $dialogRef = this.$dialog.open(
      PromptComponent,
      {
        autoFocus: true,
        width: 'auto',
        height: 'auto',
        minHeight: '12rem',
        minWidth: '25rem',
        data,
        disableClose: true,
        panelClass: 'prompt-dialog'
      }
    );

    $dialogRef.afterClosed().subscribe(res => {
      cb(res);
    });
  }
}
